import { useState } from "react";

const categories = ["Elektronik", "Aksesuar", "Ofis", "Giyim"];
const brands = ["Logitech", "Samsung", "Apple", "Dell", "HP", "Corsair"];
const warehouses = ["Ana Depo", "İstanbul Şube", "İzmir Şube"];

const allData = [
  { product: "Kablosuz Mouse", category: "Elektronik", brand: "Logitech", purchaseQty: 100, purchasePrice: 280, saleQty: 45, salePrice: 450, warehouse: "Ana Depo" },
  { product: "Mechanik Klavye", category: "Elektronik", brand: "Corsair", purchaseQty: 60, purchasePrice: 750, saleQty: 32, salePrice: 1200, warehouse: "Ana Depo" },
  { product: "27\" Monitör", category: "Elektronik", brand: "Samsung", purchaseQty: 30, purchasePrice: 2400, saleQty: 18, salePrice: 3500, warehouse: "Ana Depo" },
  { product: "USB-C Hub", category: "Aksesuar", brand: "Dell", purchaseQty: 150, purchasePrice: 180, saleQty: 62, salePrice: 320, warehouse: "İstanbul Şube" },
  { product: "Webcam 1080p", category: "Elektronik", brand: "Logitech", purchaseQty: 80, purchasePrice: 420, saleQty: 56, salePrice: 680, warehouse: "Ana Depo" },
  { product: "Laptop Standı", category: "Aksesuar", brand: "HP", purchaseQty: 120, purchasePrice: 150, saleQty: 64, salePrice: 290, warehouse: "İzmir Şube" },
  { product: "Masa Lambası LED", category: "Ofis", brand: "Samsung", purchaseQty: 200, purchasePrice: 95, saleQty: 192, salePrice: 180, warehouse: "Ana Depo" },
  { product: "Hoparlör 2.1", category: "Elektronik", brand: "Logitech", purchaseQty: 40, purchasePrice: 520, saleQty: 38, salePrice: 850, warehouse: "İstanbul Şube" },
];

export default function ProductPurchaseSaleReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [product, setProduct] = useState("");
  const [category, setCategory] = useState("");
  const [brand, setBrand] = useState("");
  const [warehouse, setWarehouse] = useState("");

  const data = allData.filter((i) => {
    if (product && !i.product.toLowerCase().includes(product.toLowerCase())) return false;
    if (category && i.category !== category) return false;
    if (brand && i.brand !== brand) return false;
    if (warehouse && i.warehouse !== warehouse) return false;
    return true;
  });

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-accent-700 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Ürün Alış-Satış Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setProduct(""); setCategory(""); setBrand(""); setWarehouse(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün</label>
            <input type="text" placeholder="Ürün adı..." value={product} onChange={(e) => setProduct(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Kategori</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {categories.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Marka</label>
            <select value={brand} onChange={(e) => setBrand(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {brands.map((b) => <option key={b} value={b}>{b}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Depo</label>
            <select value={warehouse} onChange={(e) => setWarehouse(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {warehouses.map((w) => <option key={w} value={w}>{w}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Alış - Satış Karşılaştırma</h2>
        <span className="text-sm text-foreground-500">{data.length} ürün</span>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Kategori</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Alış Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Alış Fiyat</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Satış Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Satış Fiyat</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Kâr</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => {
              const profit = (item.salePrice - item.purchasePrice) * item.saleQty;
              return (
                <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                  <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                  <td className="px-4 py-3 text-foreground-500">{item.category}</td>
                  <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                  <td className="px-4 py-3 text-center text-foreground-700">{item.purchaseQty}</td>
                  <td className="px-4 py-3 text-right text-foreground-500">${item.purchasePrice.toLocaleString("en-US")}</td>
                  <td className="px-4 py-3 text-center font-semibold text-foreground-900">{item.saleQty}</td>
                  <td className="px-4 py-3 text-right text-foreground-500">${item.salePrice.toLocaleString("en-US")}</td>
                  <td className="px-4 py-3 text-right font-semibold text-primary-600">${profit.toLocaleString("en-US")}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => {
          const profit = (item.salePrice - item.purchasePrice) * item.saleQty;
          return (
            <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
              <p className="text-sm font-medium text-foreground-900">{item.product}</p>
              <p className="text-xs text-foreground-400">{item.category} · {item.brand}</p>
              <div className="flex items-center justify-between mt-2">
                <div className="flex gap-3">
                  <div><p className="text-xs text-foreground-400">Alış</p><p className="text-sm font-medium text-foreground-700">{item.purchaseQty}</p></div>
                  <div><p className="text-xs text-foreground-400">Satış</p><p className="text-sm font-medium text-foreground-900">{item.saleQty}</p></div>
                </div>
                <p className="text-sm font-bold text-primary-600">${profit.toLocaleString("en-US")}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}